<template>
  <div class="search">
    <div class="main">
      <div class="header">
        <div class="logo-text">CHeKT Bridge</div>
      </div>

      <transition name="moveup" mode="out-in" appear>

      <!-- Search view -->
      <div 
      v-if="!isHistoryVisible"
      v-bind:key="'historyInvisible'"
      class="body">
        <div class="search-input-container">
          <!-- <div class="instruction-text">{{myName ? 'Hi ' + myName : 'Connect your local video storage'}}</div>  -->
          <div 
          v-for="(site, siteId) in mySites"
          v-bind:key="siteId"
          v-on:click="getSiteCameras(siteId)"
          class="instruction-text">{{site.name}}</div> 
          <div class="input-container">
            <input
            type="text"
            placeholder="Enter mac address"
            v-on:keyup.enter="goToHome()"
            class="mac-input" />
            <div 
            v-on:click="test()"
            class="connect-btn">
              <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"/>
              </svg>
            </div>
          </div>
          <div class="action-btns">
            <div 
            v-on:click="showHistory()"
            class="action-btn">View history</div>
          </div> 
        </div>
      </div><!-- Search view -->

      <!-- History view -->
      <div 
      v-if="isHistoryVisible"
      v-bind:key="'historyVisible'"
      class="body">
        <div class="search-input-container">

          <div class="history-container">
            <div class="description-text">Recently connected...</div>
            <div class="bridges">
              <div 
              v-for="(mac, index) in mockupMacAddresses" 
              v-bind:key="mac"
              v-if="index < 5"
              v-on:click="goToHome()"
              class="bridge-btn">{{mac}}</div>
            </div>
          </div>

          <div class="action-btns">
            <div 
            v-on:click="hideHistory()"
            class="action-btn">Hide history</div>
          </div> 
        </div>
      </div><!-- History view -->

      </transition>
    </div>
  </div>
</template>

<script>

export default {
  name: 'search',
  data () {
    return {
      isHistoryVisible: false,
      recentlyViewdMacAddresses: [],
      mockupMacAddresses: [
        '6EF403752355',
        'CAF931D46A50',
        '70B6E8F8EB79',
        '514EFFA89A11',
        '7C781AB2151D'
      ]
    }
  },
  computed: {
    myName: function () {
      return this.$store.getters.myName
    },
    mySites: function () {
      return this.$store.getters.mySites
    }
  },
  methods: {
    goToHome: function () {
      this.$router.push('home')
    },
    test: function () {
      // this.$store.dispatch('getMyProfile')
      this.$store.dispatch('getMySites')
      // this.$auth.login()
    },
    getSiteCameras: function (siteId) {
      this.$store.dispatch('getSiteCameras', siteId)
      this.$store.dispatch('getSiteMembers', siteId)
      this.$store.dispatch('getSiteContacts', siteId)
    },
    showHistory: function () {
      this.isHistoryVisible = true
    },
    hideHistory: function () {
      this.isHistoryVisible = false
    }
  }
}
</script>

<style scoped>
.search {
  background-color: #e9eaee;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  user-select: none;
}

.main {
  background-color: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.header {
  position: absolute;
  top: 0;
  width: calc(100% - 20px);
  height: 4rem;
}
.logo-text {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  height: 4rem;
}



.body {
  width: calc(100% - 20px);
  background-color: hsl(212, 50%, 50%);
  margin-top: calc(4rem - 10px);
  height: calc(100% - 4rem - 10px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.search-input-container {
  font-size: 16px;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.search-input-container .instruction-text {
  color: #fff;
  padding: 1em;
  font-size: 1.5em;
  max-width: 500px;
  width: calc(100% - 2em);
}
.search-input-container .input-container {
  max-width: 500px;
  width: calc(100% - 2em);
  position: relative;
}
.search-input-container .input-container .connect-btn {
  position: absolute;
  top: 0;
  right: 0;
  height: 52px;
  width: 52px;
  cursor: pointer;
  background-color: hsl(212, 70%, 30%);
  color: #fff;
}
.search-input-container .input-container .connect-btn svg {
  fill: currentColor;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.search-input-container .mac-input {
  /* Remove First */
  -webkit-appearance: none;
  -moz-appearance: none;

  /* Then Style */
  border-radius: 0px;
  width: calc(100% - 2em - 2px);
  font-size: 1em;
  padding: 0 1em;
  height: 50px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.3);
  border: 1px solid #ddd;
  outline: none;
}
.search-input-container .action-btns {
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  max-width: 500px;
  width: calc(100% - 2em);
  padding: 1em;
}
.search-input-container .action-btn {
  padding: 0;
  cursor: pointer;
  width: 100%;
  background-color: rgba(0,0,0,0);
  height: 3em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: background .3s;
}
.search-input-container .action-btn:hover {
  background-color: rgba(0,0,0,0.04);
}
.search-input-container .action-btn:hover {
  background-color: rgba(0,0,0,0.1);
}




.history-container {
  font-size: 16px;
  width: 100%;
  text-align: center;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.history-container .description-text {
  color: #fff;
  padding: 1em;
  font-size: 1.5em;
  max-width: 500px;
  width: calc(100% - 2em);
}
.history-container .bridges {
  max-width: 500px;
  width: calc(100% - 2em);
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: ms-autohiding-scrollbar;
}
.history-container .bridges::-webkit-scrollbar {
  display: none;
} 
.history-container .bridge-btn {
  padding: 1em 0;
  width: 100%;
  cursor: pointer;
  background-color: #fff;
  /* margin: 0.5em 0; */
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  transition: background .3s;
}
.history-container .bridge-btn:hover {
  background-color: hsl(204, 50%, 50%);
  color: #fff;
}
.history-container .bridge-btn:active {
  background-color: hsl(204, 50%, 50%);
  color: #fff;
  box-shadow: 0 0px 0px rgba(0,0,0,0.2);
}
.history-container .more-btn {
  padding: 1em;
  width: 302px;
  cursor: pointer;
  margin: 0.5em 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  background-color: #fff;
  color: #aaa;
  transition: background .3s;
}
.history-container .more-btn:hover {
  background-color: hsl(204, 0%, 30%);
  color: #fff;
}
.history-container .more-btn:active {
  background-color: hsl(204, 0%, 30%);
  color: #fff;
  box-shadow: 0 0px 0px rgba(0,0,0,0.2);
}

</style>



// WEBPACK FOOTER //
// Search.vue?7e2f450d